import {
  Button,
  Menu,
  MenuItem,
  MenuList,
  MenuTrigger,
  NaChevronDown,
  NaMenu,
} from '@metservicedev/met-ui';

import { useAuth } from '../context/AuthProvider';
import { createStyles } from '../tss';
import { MetServiceLogo } from './MetServiceLogo';

const useStyles = createStyles(({ theme }) => ({
  root: {
    backgroundColor: '#172344',
    color: '#ffffff',
    display: 'flex',
    flexDirection: 'row',
    height: 44,
    padding: `${theme.spacing(1)}px 10px ${theme.spacing(1)}px ${theme.spacing(3)}px`,
    width: '100%',
  },
  logo: {
    flexShrink: 0,
  },
  fill: {
    flex: 1,
  },
  button: {
    '&:hover': {
      background: 'unset',
    },
    color: 'inherit',
    height: 'unset',
  },
  username: {
    [theme.breakpoints.below('xs')]: {
      display: 'none',
    },
  },
  usericon: {
    [theme.breakpoints.above('xs')]: {
      display: 'none',
    },
  },
}));

export const MenuBar: React.FC = () => {
  const auth = useAuth();
  const { classes } = useStyles();

  return (
    <header className={classes.root}>
      <MetServiceLogo className={classes.logo} data-testid="metservice-logo" />
      <div className={classes.fill} />
      <Menu positioning={{ placement: 'top-end' }}>
        <MenuTrigger asChild>
          <Button
            className={classes.button}
            data-testid="button-account"
            variant="tertiary"
          >
            <span className={classes.username}>
              {auth.user?.email ?? 'Unknown User'}
            </span>
            <NaChevronDown className={classes.username} />
            <NaMenu className={classes.usericon} size={28} />
          </Button>
        </MenuTrigger>
        <MenuList>
          <MenuItem
            data-testid="log-out"
            value="log-out"
            onClick={() => auth.logOut()}
          >
            Log out
          </MenuItem>
        </MenuList>
      </Menu>
    </header>
  );
};
